import { DepartmentEnum, RolesEnum, CurrencyEnum, UserSettingsInterface } from "@finway-group/shared/lib/models"
import { validEmail, validObjectId } from "./shared"

const phoneNumber = "+16502222323"
const phoneNumberGer = "+4910981234"

// employee
export const devUserData = {
    id: "209382697352811920948269",
    email: "x.mustermann@finway.de",
    password: "9jb98Vwh",
    firstName: "Xaver",
    lastName: "Mustermann",
    dateOfBirth: Date.now(),
    hiredDate: Date.now(),
    location: "Passau",
    workPhone: phoneNumber,
    position: "Developer",
    department: DepartmentEnum.ENGINEERING,
    role: RolesEnum.EMPLOYEE,
    approvals: [],
    settings: {
        globalCurrency: CurrencyEnum.USD,
        showExpenseNumbers: true,
    } as UserSettingsInterface,
}

export const designerUserData = {
    id: "309382697352811920948269",
    email: "f.mustermann@finway.de",
    password: "9jb98Vwh",
    firstName: "Fred",
    lastName: "Mustermann",
    dateOfBirth: Date.now(),
    hiredDate: Date.now(),
    location: "Passau",
    position: "UX Engineer",
    department: DepartmentEnum.ENGINEERING,
    role: RolesEnum.EMPLOYEE,
    approvals: [],
    settings: {
        globalCurrency: CurrencyEnum.USD,
        showExpenseNumbers: true,
    } as UserSettingsInterface,
}

export const devInternUserData = {
    id: "409382697352811920948269",
    email: "s.mustermann@finway.de",
    password: "9jb98Vwh",
    firstName: "Steffanie",
    lastName: "Mustermann",
    dateOfBirth: Date.now(),
    hiredDate: Date.now(),
    location: "Passau",
    position: "Intern",
    department: DepartmentEnum.ENGINEERING,
    role: RolesEnum.EMPLOYEE,
    approvals: [],
    settings: {
        globalCurrency: CurrencyEnum.USD,
        showExpenseNumbers: true,
    } as UserSettingsInterface,
}

export const internUserData = {
    id: "809382697352811920948269",
    email: "e.mustermann@finway.de",
    password: "9jb98Vwh",
    firstName: "Elfriede",
    lastName: "Mustermann",
    dateOfBirth: Date.now(),
    hiredDate: Date.now(),
    location: "Passau",
    position: "Intern",
    department: DepartmentEnum.MARKETING,
    role: RolesEnum.EMPLOYEE,
    approvals: [],
    settings: {
        globalCurrency: CurrencyEnum.USD,
        showExpenseNumbers: true,
    } as UserSettingsInterface,
}

// approver
export const teamLeadUserData = {
    id: "509382697352811920948269",
    email: "m.mustermann@finway.de",
    password: "9jb98Vwh",
    firstName: "Max",
    lastName: "Mustermann",
    dateOfBirth: Date.now(),
    hiredDate: Date.now(),
    location: "Munich",
    workPhone: phoneNumber,
    position: "Team Lead",
    department: DepartmentEnum.ENGINEERING,
    role: RolesEnum.APPROVER,
    approvals: [],
    settings: {
        globalCurrency: CurrencyEnum.USD,
        showExpenseNumbers: true,
    } as UserSettingsInterface,
}

// admin
export const financeUserData = {
    id: "609382697352811920948269",
    email: "g.mustermann@finway.de",
    password: "9jb98Vwh",
    firstName: "Greta",
    lastName: "Mustermann",
    dateOfBirth: Date.now(),
    hiredDate: Date.now(),
    location: "Munich",
    workPhone: phoneNumberGer,
    position: "Financial Worker",
    department: DepartmentEnum.FINANCE,
    role: RolesEnum.ADMIN,
    approvals: [],
    settings: {
        globalCurrency: CurrencyEnum.USD,
        showExpenseNumbers: true,
    } as UserSettingsInterface,
}

export const teamLeadData = {
    id: "709382697352811920948269",
    email: "a.bejaoui@finway.de",
    password: "9jb98Vwh",
    firstName: "Ahmed",
    lastName: "Bejaoui",
    dateOfBirth: Date.now(),
    hiredDate: Date.now(),
    location: "Munich",
    workPhone: phoneNumberGer,
    position: "Team Lead",
    department: DepartmentEnum.ENGINEERING,
    role: RolesEnum.APPROVER,
    approvals: [],
    settings: {
        globalCurrency: CurrencyEnum.USD,
        showExpenseNumbers: true,
    } as UserSettingsInterface,
}

export const cfoUserData = {
    id: "909382697352811920948269",
    email: "j.dussileck@finway.de",
    password: "9jb98Vwh",
    firstName: "Jennifer",
    lastName: "Dussileck",
    dateOfBirth: Date.now(),
    hiredDate: Date.now(),
    location: "Munich",
    workPhone: phoneNumberGer,
    position: "CFO",
    department: DepartmentEnum.MANAGEMENT,
    role: RolesEnum.ADMIN,
    approvals: [],
    settings: {
        globalCurrency: CurrencyEnum.USD,
        showExpenseNumbers: true,
    } as UserSettingsInterface,
}

export const ceoUserData = {
    id: "219382697352811920948269",
    email: "c.kruemmer@finway.de",
    password: "9jb98Vwh",
    firstName: "Csaba",
    lastName: "Kümmer",
    dateOfBirth: Date.now(),
    hiredDate: Date.now(),
    location: "Munich",
    workPhone: phoneNumber,
    position: "CEO",
    department: DepartmentEnum.MANAGEMENT,
    role: RolesEnum.ADMIN,
    approvals: [],
    settings: {
        globalCurrency: CurrencyEnum.USD,
        showExpenseNumbers: true,
    } as UserSettingsInterface,
}

export const cpoUserData = {
    id: "249382697352811920948269",
    email: "j.schwoebel@finway.de",
    password: "9jb98Vwh",
    firstName: "Jan",
    lastName: "Schwoebel",
    dateOfBirth: Date.now(),
    hiredDate: Date.now(),
    location: "Raleigh",
    position: "DevOps",
    department: DepartmentEnum.ENGINEERING,
    role: RolesEnum.ADMIN,
    approvals: [],
    settings: {
        globalCurrency: CurrencyEnum.USD,
        showExpenseNumbers: true,
    } as UserSettingsInterface,
}

export const ctoUserData = {
    id: "206382697352811920948269",
    email: "p.rieger@finway.de",
    password: "9jb98Vwh",
    firstName: "Philipp",
    lastName: "Rieger",
    dateOfBirth: Date.now(),
    hiredDate: Date.now(),
    location: "Munich",
    workPhone: phoneNumber,
    position: "CTO",
    department: DepartmentEnum.MANAGEMENT,
    role: RolesEnum.ADMIN,
    approvals: [],
    settings: {
        globalCurrency: CurrencyEnum.USD,
        showExpenseNumbers: true,
    } as UserSettingsInterface,
}

// only for unit tests
export const testUserData = {
    id: "209482697352811920948269",
    email: "test@finway.de",
    password: "wkjc9ri9",
    firstName: "Test",
    lastName: "Tester",
    dateOfBirth: Date.now(),
    hiredDate: Date.now(),
    location: "Munich",
    workPhone: phoneNumber,
    position: "Developer",
    department: DepartmentEnum.ENGINEERING,
    role: RolesEnum.ADMIN,
    approvals: [],
    settings: {
        globalCurrency: CurrencyEnum.USD,
        showExpenseNumbers: true,
    } as UserSettingsInterface,
}

// first user for deployment
export const adminUserData = {
    id: "209392697352811920948269",
    email: "admin@finway.de",
    password: "V6h5Om5T",
    firstName: "Admin",
    lastName: "User",
    dateOfBirth: Date.now(),
    hiredDate: Date.now(),
    location: "Admin",
    position: "Tester",
    department: DepartmentEnum.ENGINEERING,
    role: RolesEnum.ADMIN,
    approvals: [],
    settings: {
        globalCurrency: CurrencyEnum.USD,
        showExpenseNumbers: true,
    } as UserSettingsInterface,
}

export const mainUserData = {
    id: validObjectId,
    email: validEmail,
    firstName: "Max",
    lastName: "Mustermann",
    position: "CEO",
    location: "Munich",
    department: DepartmentEnum.MANAGEMENT,
    isAdmin: true,
    isApprover: true,
    role: RolesEnum.ADMIN,
    approvals: [],
    settings: {
        globalCurrency: CurrencyEnum.USD,
        showExpenseNumbers: true,
    } as UserSettingsInterface,
}
